import React, { useEffect, useState } from "react";

import { FiUpload } from "react-icons/fi";
import { userPlaceholderIcon } from "assets/images";

import { IoMdArrowRoundBack } from "react-icons/io";
import { Link, useNavigate, useParams } from "react-router-dom";
// import { editstudentApi, studentDetailApi } from "services/students";
import useButtonLoader from "common/UseButtonLoader";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";
import { allowNumber, regex } from "utils/formValidator";
import { Input } from "common/InputForm";
import { FaEdit } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { setPersonalInfo } from "store/slices/userDataStore";
import { editProfileApi, profileDetailApi } from "services/profile";

const ProfileUpdate = () => {
  const { imageFileRegex } = regex;
  const { id } = useParams();
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Save");
  const [loader, onShow, onHide] = useFullPageLoader();
  const [errors, setErrors] = useState({});
  const [inputData, setInputData] = useState({});
  const navigate = useNavigate();
  let localData = localStorage.getItem('adminInfo')
    ? JSON.parse(localStorage.getItem('adminInfo'))
    : {}
  // console.log(localData, "localData")
  // fetchStudent Deatil
  const fetchingProfileDetail = async () => {
    try {
      onShow();
      const res = await profileDetailApi();
      if (res.data.status === 200) {
        setInputData(res.data.data.user);
        // console.log(res.data.data, "res.data.data");
      } else {
        toastMessage(res.data.message, "error", "studentDetail");
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      onHide();
    }
  };

  // const dispatch = useDispatch();

  // const handleUpdatePersonalInfo = (data) => {
  //   const newPersonalInfo = {
  //     data
  //   };
  //   // Dispatch the action to update personalInfo in the Redux store
  //   dispatch(setPersonalInfo({ personalInfo: newPersonalInfo }));
  // };

  const validation = () => {
    let status = true;
    const error = {};
    console.log(error, "err");
    if (!inputData.name) {
      error["name"] = "Please enter name";
      status = false;
    }
    if (!inputData.mobile) {
      error["mobile"] = "Please enter mobile";
      status = false;
    }
    // if (!inputData.logo && !media.logo) {
    //   error["logo"] = "Please upload employer company logo";
    //   status = false;
    // }
    setErrors(error);
    return status;
  };
  // console.log('inputData', inputData)

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "mobile") {
      setInputData({ ...inputData, [name]: allowNumber(value) });
    } else {
      setInputData({ ...inputData, [name]: value });
    }
  };

  // update student
  const updateProfile = async (e) => {
    e.preventDefault();

    if (validation()) {
      setButtonLoaders(true);
      try {
        const formData = new FormData();
        formData.append("name", inputData.name);
        formData.append("mobile", inputData.mobile || "");
        formData.append("countryCode", inputData.countryCode || "");

        formData.append("profile", inputData.profile);



        const res = await editProfileApi(formData);
        if (res?.data?.status === 200) {
          // handleUpdatePersonalInfo(inputData)
          toastMessage(
            "Admin updated successfully",
            "success",
            "updateProfile"
          );
          fetchingProfileDetail(id)
          navigate(-1);
        } else {
          toastMessage(res?.data?.message, "error", "updateProfile");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };
  // const filesHandler = (e) => {
  //   const file = e.target.files[0];
  //   if (file && imageFileRegex.test(file.name)) {
  //     const filePreviewUrl = URL.createObjectURL(file);
  //     setProfileImage(file)
  //     setInputData((prevState) => ({
  //       ...prevState,
  //       profile: file,
  //       profilePreview: filePreviewUrl,
  //     }));
  //   }
  // };
  const filesHandler = (e) => {
    const file = e.target.files[0];
    if (file && imageFileRegex.test(file.name)) {
      // setProfileImage(file); // ✅ सही तरीके से File object स्टोर करें
      setInputData((prevState) => ({
        ...prevState,
        profile: file, // ✅ inputData.profile में भी File object रखें
        profilePreview: URL.createObjectURL(file),
      }));
    }
  };

  useEffect(() => {
    fetchingProfileDetail(id);
  }, []);
  return (
    <>
      {loader}
      <div className="editProfile">
        <div className="dashboard_title has_child">
          <div className="breadcrumb">
            <ul>
              <li>
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li> My Profile</li>
            </ul>
          </div>
          <button
            type="button"
            onClick={updateProfile}
            ref={buttonLoaders}
            className="button"
          >
            Save
          </button>
        </div>
        <div className="personal_details d-block _box spacing">
          <div className="image_wrap">
            {inputData.profilePreview ? (
              <img src={inputData.profilePreview} alt="" />
            ) : (
              <img
                src={
                  inputData?.profile ? inputData?.profile : userPlaceholderIcon
                }
                alt=""
              />
            )}
            <label htmlFor="profile_image" className="upload_button">
              <input
                type="file"
                id="profile_image"
                onChange={(e) => filesHandler(e)}
              />
              <FaEdit />
            </label>
          </div>

          <div className="form_field_wrap">
            <div className="form_field">
              <Input
                label={"Admin Name"}
                className={"form-control input"}
                type={"name"}
                value={inputData.name || ""}
                onChange={onChangeHandler}
                placeholder={"Enter name"}
                name={"name"}
                error={errors?.name}
              />
            </div>
            <div className="form_field"></div>
          </div>
          <div className="form_field_wrap">
            <div className="form_field">
              <label className="label">Contact Number</label>
              <div className="has_country_code">
                <span className="country_code">+91</span>

                <Input
                  className={"form-control input"}
                  type={"mobile"}
                  value={inputData.mobile || ""}
                  onChange={onChangeHandler}
                  placeholder={"Enter Mobile"}
                  name={"mobile"}
                  error={errors?.mobile}
                />
              </div>
            </div>
            <div className="form_field"></div>
          </div>

        </div>
      </div>

    </>
  );
};
export default ProfileUpdate;
